import api from './api';

export interface Entitlement {
  vertical: string | null;
  tier: string;
  active_matter_slots: number | null;
  features: string[];
  status: string; // trialing|active|expired|revoked|fallback
  source: string; // engine_push|provisional_trial|plan_limits_fallback
  /** ISO timestamp the trial ends, or null for no clock — paid rows, whose
   *  period the engine owns, and pre-cutover trials. Until this existed the
   *  trial banner could not count down at all. */
  trial_ends_at?: string | null;
}

export const entitlementsApi = {
  /** Per-vertical entitlements for the signed-in lawyer (GET /entitlements/me). */
  async getMine(): Promise<Entitlement[]> {
    const response = await api.get('/entitlements/me');
    return response.data;
  },
};
